<template>
    <div
        class="position-relative custom-dropdown"
        @keyup.escape.prevent="onEscape"
        @keyup.space="onKeypressToOpen"
        @keyup.enter="onKeypressToOpen"
        @keyup.down="onArrowDown"
        @keyup.up="onArrowUp"
        @blur="onBlur"
        @click="onButtonClicked"
        tabindex="0"
        ref="dropdownBtn"
    >
        <span
            class="d-inline-block py-1 px-2 rounded cursor-pointer"
            :style="getStyle"
        >
            <div v-if="loading" class="spinner-border spinner-border-sm text-white mr-1" role="status">
                <span class="sr-only">Loading...</span>
            </div>
            {{ getName }}
        </span>
        <div class="custom-dropdown-menu" ref="dropdownMenu" v-if="dropdownOpen">
            <button
                v-for="(option, index) in options"
                :key="index"
                @keydown.enter.prevent="selectDropdown(option.key)"
                @keydown.space.prevent="selectDropdown(option.key)"
                @click.prevent.stop="selectDropdown(option.key)"
                @mouseover="selectDropdownCounter(index)"
                :class="{ 'is-active' : dropdownCounter == index}"
                v-html="option.value"
            ></button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Dropdown',
    props: {
        value: { type: String, required: true },
        options: { type: Array, required: true },
        loading: { type: Boolean, required: false, default: false },
    },
    data() {
        return {
            dropdownOpen: false,
            dropdownCounter: -1,
        };
    },
    mounted() {
        const repositionDropdown = () => {
            if (this.dropdownOpen) {
                this.setDropdownMenuPosition();
            }
        };

        window.addEventListener('scroll', repositionDropdown);
        window.addEventListener('resize', repositionDropdown);

        const datatable = this.$refs.dropdownBtn.closest('.table-responsive');
        datatable.addEventListener('scroll', repositionDropdown);
    },
    methods: {
        setDropdownMenuPosition() {
            this.$nextTick(() => {
                const rectBtn = this.$refs.dropdownBtn.getBoundingClientRect();
                const rectMenu = this.$refs.dropdownMenu.getBoundingClientRect();
                const windowHeight = window.innerHeight;
                const windowWidth = window.innerWidth;
                const heightMenu = rectMenu.height;
                const widthMenu = rectMenu.width;
                const spaceBelow = windowHeight - rectBtn.bottom;
                const spaceRight = windowWidth - rectBtn.left;

                if (spaceBelow < heightMenu) {
                    this.$refs.dropdownMenu.style.top = rectBtn.top - heightMenu - 1 + 'px';
                } else {
                    this.$refs.dropdownMenu.style.top = rectBtn.bottom + 1 + 'px';
                }

                if (spaceRight < widthMenu) {
                    this.$refs.dropdownMenu.style.left = rectBtn.right - widthMenu + 'px';
                } else {
                    this.$refs.dropdownMenu.style.left = rectBtn.left + 'px';
                }
            })
        },
        selectDropdown(option) {
            let selectedOption = option;

            if (this.dropdownCounter > -1) {
                selectedOption = this.options.filter((option, index) => index == this.dropdownCounter)[0].key;
            }

            if (selectedOption == this.value) {
                this.dropdownOpen = false;
                return;
            }

            this.$emit('input', selectedOption);
            this.dropdownOpen = false;
        },
        onButtonClicked() {
            this.dropdownOpen = ! this.dropdownOpen;
            if (this.dropdownOpen == false) {
                this.dropdownCounter = -1;
            }
        },
        onKeypressToOpen() {
            if (this.dropdownOpen == false) {
                this.dropdownOpen = true;
            } else {
                if (this.dropdownCounter > -1) {
                    let selectedOption = this.options.filter((option) => option.key == this.value)[0].key;
                    this.selectDropdown(selectedOption);

                    this.dropdownOpen = false;
                } else {
                    this.dropdownOpen = false;
                }
            }
        },
        onEscape() {
            this.dropdownOpen = false;
            this.dropdownCounter = -1;
        },
        onBlur(event) {
            if (! event.currentTarget.contains(event.relatedTarget)) {
                this.dropdownOpen = false;
                this.dropdownCounter = -1;
            }
        },
        selectDropdownCounter(index) {
            this.dropdownCounter = index;
        },
        onArrowUp() {
            this.dropdownCounter = this.dropdownCounter - 1;
            if (this.dropdownCounter < 0) {
                this.dropdownCounter = 0;
            }
        },
        onArrowDown() {
            this.dropdownCounter = this.dropdownCounter + 1;
            if (this.dropdownCounter >= 4) {
                this.dropdownCounter = 3;
            }
        }
    },
    computed: {
        getStyle() {
            for (let option of this.options) {
                if (this.value === option.key) {

                    return 'background-color:' + option.color + ';' + 'color:white;';
                }
            }

            return 'background-color:#dddddd;color:white;';
        },
        getName() {
            return this.options.filter((option) => option.key == this.value)[0].value;
        },
    },
    watch: {
        dropdownOpen(value) {
            if (value) {
                this.setDropdownMenuPosition()
            }
        }
    }
}
</script>

<style scoped>
.custom-dropdown {
    appearance: none;
    border: solid 0px transparent;
    background-color: transparent;
    padding: 0;
    border-radius: 4px;
    outline: none;
}
.custom-dropdown span {
    white-space: nowrap;
}
.custom-dropdown:focus .option-reserved, .custom-dropdown:hover .option-reserved {
    background-color: #c6c24e;
}
.custom-dropdown:focus .option-sent_to_publisher, .custom-dropdown:hover .option-sent_to_publisher {
    background-color: #1581af;
}
.custom-dropdown:focus .option-published, .custom-dropdown:hover .option-published {
    background-color: #15b170;
}
.custom-dropdown:focus .option-cancelled, .custom-dropdown:hover .option-cancelled {
    background-color: #b9bec4;
}
.custom-dropdown-menu {
    position: fixed;
    background-color: white;
    border: solid 1px #CED4DA;
    border-radius: 4px;
    z-index: 50;
    min-width: 140px;
}
.custom-dropdown-menu button {
    display: block;
    appearance: none;
    width: 100%;
    background-color: white;
    border: solid 0px transparent;
    border-radius: 4px;
    padding: 0.25rem 0.5rem;
}
.custom-dropdown-menu button.is-active {
    background-color: #eee;
}
</style>